import Header from "./components/header";
import Intro from "./components/Intro";
import Contact from "./components/contact";
import "./css/header.css";
import "./css/intro.css";
import "./css/contact.css";
import { useEffect, Suspense, lazy } from "react";
import About from './components/About';
import Projects from './components/Projects';
import Skills from './components/Skills';
import Footer from './components/footer';
import './css/footer.css';
import { motion } from 'framer-motion';

// New UI/UX Components
import ErrorBoundary from './components/ErrorBoundary';
import CustomCursor from './components/CustomCursor';
import ScrollProgress from './components/ScrollProgress';
import ParticlesBackground from './components/ParticlesBackground';
import LoadingSpinner from './components/LoadingSpinner';

function App() {
  useEffect(() => {
    // Smooth scrolling for all anchor links
    const handleSmoothScroll = (event) => {
      const anchor = event.target.closest('a[href^="#"]');

      if (anchor) {
        event.preventDefault();
        const href = anchor.getAttribute('href');

        if (href === '#') {
          window.scrollTo({ top: 0, behavior: 'smooth' });
          return;
        }

        const targetElement = document.querySelector(href);

        if (targetElement) {
          targetElement.scrollIntoView({
            behavior: 'smooth'
          });
        }
      }
    };
    document.addEventListener('click', handleSmoothScroll);
    // Add fade-in animation to sections when they come into view
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('fade-in-up');
        }
      });
    }, {
      threshold: 0.1
    });

    // Observe all sections
    document.querySelectorAll('section').forEach(section => {
      observer.observe(section);
    });

    // Cleanup
    return () => {
      document.removeEventListener('click', handleSmoothScroll);
      observer.disconnect();
    };
  }, []);
  return (
    <ErrorBoundary>
      <CustomCursor />
      <ScrollProgress />
      <ParticlesBackground />

      <div className="App">
        <Header />
        <Intro />
        <About />
        <Projects />
        <Skills />

        <section className="contact" id="contact">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h3>What's Next?</h3>
            <h2 className="section-heading">Get In Touch</h2>
            <p className="para">
              Let’s Chat! Whether you have a question, a project idea, or just want to connect, I’m always happy to hear from you. Drop me a message, and I’ll be in touch soon!
            </p>
            <Contact />
          </motion.div>
        </section>

        <Footer />
      </div>
    </ErrorBoundary>
  );
}

export default App;